document.addEventListener('DOMContentLoaded', () => {

  document.addEventListener('click', (event) => {

  const trigger = event.target.closest(
    '.velozia-quick-add__mobile-trigger'
  );

  if (!trigger) return;

  event.preventDefault();
  event.stopPropagation();

  const quickAdd = trigger.closest('.velozia-quick-add');

  if (!quickAdd) return;

  const isOpen = quickAdd.classList.toggle('is-open');

  trigger.setAttribute(
    'aria-expanded',
    isOpen ? 'true' : 'false'
  );

});

  document.addEventListener('click', async (event) => {

const button = event.target.closest('.velozia-size-button');

if (!button || button.disabled) return;

event.preventDefault();
event.stopPropagation();
event.stopImmediatePropagation();

const variantId = button.dataset.variantId;

    if (!variantId) return;

    button.disabled = true;
    button.classList.add('loading');

    const spinner = button.querySelector('.loading__spinner');

    if (spinner) {
      spinner.classList.remove('hidden');
    }

    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        }
      );

      if (!response.ok) {
        throw new Error('Unable to add product');
      }

      /*
       * Product has been added successfully.
       * Reload the collection page and automatically
       * reopen the freshly rendered cart drawer.
       */
      sessionStorage.setItem(
        'veloziacollectiondrawer',
        'open'
      );

      window.location.reload();

    } catch (error) {

      console.error(
        'Velozia Collection Quick Add:',
        error
      );

      button.disabled = false;
      button.classList.remove('loading');

      if (spinner) {
        spinner.classList.add('hidden');
      }

      alert(
        'Sorry, this item could not be added. Please try again.'
      );
    }

  });


  /*
   * Reopen cart drawer after Quick Add reload
   */
  window.addEventListener('load', function() {

    if (
      sessionStorage.getItem('veloziacollectiondrawer') === 'open'
    ) {

      sessionStorage.removeItem(
        'veloziacollectiondrawer'
      );

      setTimeout(function() {

        const cartDrawer =
          document.querySelector('cart-drawer');

        if (
          cartDrawer &&
          typeof cartDrawer.open === 'function'
        ) {
          cartDrawer.open();
        }

      }, 150);

    }

  });

});